import sortBy from 'lodash/sortBy';
import { type TreeNode } from '@direct-frontend/components';

export type StrippedCategoryModel = {
    id: string;
    slug?: string;
    parent_id?: string | null;
    display_sequence?: number | null;
    title: string;
};

export function groupCategoriesByParent(categories: StrippedCategoryModel[]): TreeNode[] {
    const res: TreeNode[] = [];
    const map = new Map<string, TreeNode>();

    const sortedCategories = sortBy<StrippedCategoryModel>(categories, 'display_sequence');

    sortedCategories.forEach((category) => {
        const categoryNode: TreeNode = {
            id: category.slug || category.id,
            label: category.title,
            parent: undefined,
        };

        map.set(category.id, categoryNode);
    });

    sortedCategories.forEach((category) => {
        const parentNode = category.parent_id ? map.get(category.parent_id) : undefined;

        const categoryNode = map.get(category.id) as TreeNode;

        if (parentNode) {
            categoryNode.parent = parentNode;

            if (parentNode.children) {
                parentNode.children.push(categoryNode);
            } else {
                parentNode.children = [categoryNode];
            }
        } else {
            res.push(categoryNode);
        }
    });

    return res;
}
